import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { numberFormatter } from "@common/helpers/number";
import { useBulkActions } from "../useBulkActions";

export const UnmatchAllConfirmationModal: React.FC<{
    show: boolean;
    onHide: () => void;
}> = ({ show, onHide }) => {
    const bulkActions = useBulkActions();
    const selectedTransactionsHaveTransferMatch = Object.values(
        bulkActions.selected,
    ).filter((value) => value.pairedTransferId);
    return (
        <ConfirmationModal
            show={show}
            onHide={onHide}
            onReject={onHide}
            onConfirm={async () => {
                bulkActions.updateSelected({
                    update: "pairedTransferId",
                    value: null,
                });
                onHide();
            }}
            title={`Unmatching ${numberFormatter.format(
                selectedTransactionsHaveTransferMatch.length,
            )} transactions`}
            question="Are you sure you want to unmatch selected transactions?"
            yes="Unmatch"
            yesBtnVariant="primary"
        />
    );
};
